// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__GWvL6","linksWrapper":"styles_linksWrapper__05YCd","label":"styles_label__MQC_2","link":"styles_link__Rb3_K"};